import { SproutCommonContent } from "../../../../modules/content/components/SproutCommonContent/SproutCommonContent";
import { SproutRichText } from "../../../../modules/content/components/SproutRichText/SproutRichText";
import { SproutSection } from "../../../../modules/content/components/SproutSection/SproutSection";
import type { IWysiwygBlockProps } from "./WysiwygBlock.props";

export const WysiwygBlock = ({
  alignment,
  anchorId,
  buttons,
  content,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
}: IWysiwygBlockProps) => {
  if (!content) return null;
  const hasIntro = Boolean(eyebrow || heading || description || buttons?.length);

  return (
    <SproutSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-10 md:gap-14">
        {hasIntro ? (
          <SproutCommonContent
            alignment={alignment}
            buttons={buttons}
            description={description}
            eyebrow={eyebrow}
            heading={heading}
          />
        ) : null}
        <SproutRichText
          className="relative max-w-none overflow-hidden [&_h2]:mt-12 [&_h2]:font-sprout-display [&_h2]:text-3xl [&_h2]:font-bold [&_h2]:leading-tight [&_h2:first-child]:mt-0"
          content={content}
        />
      </div>
    </SproutSection>
  );
};

WysiwygBlock.displayName = "Block::WysiwygBlock";
